<div class="container" mat-dialog-content>
    <h2>Item Feature</h2>
    <mat-form-field appearance="outline">
        <mat-label>Label</mat-label>
        <input matInput [(ngModel)]="itemFeature.label">
    </mat-form-field>

    <mat-form-field appearance="outline">
        <mat-label>Text</mat-label>
        <input matInput [(ngModel)]="itemFeatureValue">
    </mat-form-field>

</div>

<div mat-dialog-actions>
    <button (click)="save()" mat-raised-button [disabled]="(itemFeature.label == '')">Save</button>
    <button (click)="delete()" mat-raised-button>Delete</button>
</div>